import * as React from 'react';

import './UiButton.scss';

type UiButtonProps = {
  children: React.ReactNode;
  className?: string;
  size?: 'large' | 'medium' | 'small';
  type?: 'primary' | 'secondary' | 'flat';
  dataTestId?: string;
  onClick?: (event?: React.MouseEvent) => void;
};

export default function UiButton({
  className = '',
  onClick,
  children,
  size = 'large',
  type = 'primary',
  dataTestId,
}: UiButtonProps) {
  const sizeClass = size ? `btn--${size}` : '';
  const typeClass = type ? `btn--${type}` : '';

  return (
    <button
      type="button"
      className={`btn ${className} ${sizeClass} ${typeClass}`}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {children}
    </button>
  );
}
